module.exports = __webpack_public_path__ + "static/media/IADC-LOGO.3a944a3f.png";